import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';
import { useMessageContext } from '@post-office/message-context';
import { type ComponentProps } from 'react';

import { Actions } from './components/actions';
import { type JSX } from 'react/jsx-runtime';

export type Props = {
	bodyContent: React.ReactNode;
	onDismissed?: (messageInstanceId: string) => void;
	whyAmISeeingThisModalContent?: ComponentProps<typeof Actions>['whyAmISeeingThisModalContent'];
	extraAnalyticsAttributes?: Record<string, string>;
	showRemindMeLater?: boolean | undefined;
	showWhyAmISeeingThis?: boolean | undefined;
	additionalAnalyticsAttributes?: Record<string, string>;
};

const jiraSideNavMessageStyle = css({
	position: 'relative',
	display: 'flex',
	borderRadius: token('radius.large', '8px'),
	backgroundColor: token('color.background.accent.blue.subtlest', '#DEEBFF'),
	paddingInline: token('space.200', '16px'),
	paddingBlock: token('space.150', '12px'),
	marginBottom: token('space.100', '8px'),
	zIndex: 0,
});

export const JiraSideNavMessage = ({
	onDismissed,
	whyAmISeeingThisModalContent,
	bodyContent,
	showRemindMeLater,
	showWhyAmISeeingThis,
	additionalAnalyticsAttributes,
}: Props): JSX.Element => {
	const { messageInstanceId } = useMessageContext();
	if (!messageInstanceId) {
		throw new Error('messageInstanceId is required');
	}
	return (
		<div data-testid="jira-side-nav-message" css={jiraSideNavMessageStyle}>
			{bodyContent}
			<Actions
				whyAmISeeingThisModalContent={whyAmISeeingThisModalContent}
				onDismissed={() => onDismissed?.(messageInstanceId)}
				showRemindMeLater={showRemindMeLater}
				showWhyAmISeeingThis={showWhyAmISeeingThis}
				additionalAnalyticsAttributes={additionalAnalyticsAttributes}
			/>
		</div>
	);
};
